export default "__VITE_ASSET__CUq258yk__"